import React from "react";
import "./styles/Icons.css";

const CartIcon = () => {
    return (
        <svg className="carrito" version="1.1" id="cart" x="0px" y="0px" viewBox="0 0 422 437" xmlSpace="preserve">
            <path
                d="M400.5,201.5l-274.5,45c-25.5,22.5,1.504,42,1.504,42L396,290v37.5l-295.5-3
	c-12-7.5-20.992-31.5-24-52.5c-3-21,19.5-43.5,19.5-43.5L49.508,53H24l-6-33h64.504L99,74l307.5-1.5L400.5,201.5z M153,341
	c22.367,0,40.5,18.129,40.5,40.5c0,22.367-18.133,40.5-40.5,40.5c-22.371,0-40.496-18.133-40.496-40.5
	C112.504,359.129,130.629,341,153,341z M351,341c22.375,0,40.5,18.129,40.5,40.5c0,22.367-18.125,40.5-40.5,40.5
	c-22.363,0-40.5-18.133-40.5-40.5C310.5,359.129,328.637,341,351,341z"
            />
        </svg>
    );
};

export default CartIcon;
